import { Alert, AlertTitle } from "@material-ui/lab";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import useShowMessage from "customHooks/useShowMessage/useShowMessage";

interface IShowApiKeyProps {
    apiKey: string;
    t: any;
}

export function ShowApiKey(props: IShowApiKeyProps) {
    const { apiKey, t } = props;
    const showMessage = useShowMessage();

    const copyContent = (content: string) => {
        navigator.clipboard.writeText(content);
        showMessage({
            message: t("copyKeySuccessMessage"),
            timeout: 1000,
            typeMessage: "success",
            snackBarOrign: {
                vertical: "top",
                horizontal: "center"
            }
        });
    };

    return (
        <Alert>
            <AlertTitle>{t("copyKeyMessage")}</AlertTitle>
            {apiKey}
            <ButtonIconTooltipCompleo
                onClick={() => {
                    copyContent(apiKey);
                }}
                label={t("copyKey")}
                size="small"
            >
                <FileCopyIcon />
            </ButtonIconTooltipCompleo>
        </Alert>
    );
}
export default ShowApiKey;
